import React from 'react';
import InputAdornment from '@mui/material/InputAdornment';
import { SelectionTreeT } from 'business/definitions';
import SelectChevron from 'components/inputs/SelectChevron';
import { styled } from '@mui/material/styles';
import { TextFieldProps } from '@mui/material';
import Chip from './Chip';
import NumberLeft from './NumberLeft';

const StyInputAdornment = styled(InputAdornment, {
    name: 'StyInputAdornment',
})({
    width: 'inherit',
    justifyContent: 'space-between',
    fontSize: '14px',
});

const StyStartAdornment = styled(StyInputAdornment, {
    name: 'StyStartAdornment',
})({
    padding: '1vh 0',
    '& ~ .MuiInputBase-input': {
        padding: '1vh 0',
    },
});

const getChips = (
    options: SelectionTreeT[],
    onRemoveClick: (arg1: SelectionTreeT) => void,
    isValueLocked: boolean,
) => {
    if (isValueLocked) {
        return <Chip isLocked />;
    }
    const len = options.length;
    const lenToCut = 1;
    const optionsLeft = options.slice(lenToCut, len).map((opt) => opt.label);
    return (
        <>
            {options.slice(0, lenToCut).map((opt) => (
                <Chip
                    option={opt}
                    onRemoveClick={onRemoveClick}
                    key={`${opt.value}-${opt.label}`}
                />
            ))}
            {optionsLeft.length > 0 && <NumberLeft optionsLeft={optionsLeft} />}
        </>
    );
};

const AdornedInput = (
    options: SelectionTreeT[],
    onRemoveClick: (arg1: SelectionTreeT) => void,
    isValueLocked: boolean,
): TextFieldProps['InputProps'] => {
    const endAdornment = (
        <StyInputAdornment position="end">
            <SelectChevron />
        </StyInputAdornment>
    );
    const startAdornment = (
        <StyStartAdornment position="start">
            {getChips(options, onRemoveClick, isValueLocked)}
        </StyStartAdornment>
    );
    const optionIsEmpty = options.length === 0;
    return optionIsEmpty ? { endAdornment } : { startAdornment };
};

export default AdornedInput;
